Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') {
        cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /{{\s*(\w+)\s*}}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal = defaultOption(decimal, '.');
        if (isNaN(number) || number == null) {
            return 0;
        }
        number = (number / 100.0).toFixed(precision);
        var parts = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents = parts[1] ? (decimal + parts[1]) : '';
        return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }
    return formatString.replace(placeholderRegex, value);
};


// Smooth According
class Accordion {
    constructor(el) {
        // Store the <details> element
        this.el = el;
        // Store the <summary> element
        this.summary = el.querySelector('summary');
        // Store the <div class="content"> element
        this.content = el.querySelector('.accordion__content');

        // Store the animation object (so we can cancel it if needed)
        this.animation = null;
        // Store if the element is closing
        this.isClosing = false;
        // Store if the element is expanding
        this.isExpanding = false;
        // Detect user clicks on the summary element
        this.summary.addEventListener('click', (e) => this.onClick(e));
    }

    onClick(e) {
        // Stop default behaviour from the browser
        e.preventDefault();
        // Add an overflow on the <details> to avoid content overflowing
        this.el.style.overflow = 'hidden';
        // Check if the element is being closed or is already closed
        if (this.isClosing || !this.el.open) {
            this.open();
            // Check if the element is being openned or is already open
        } else if (this.isExpanding || this.el.open) {
            this.shrink();
        }
    }

    shrink() {
        // Set the element as "being closed"
        this.isClosing = true;

        // Store the current height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the height of the summary
        const endHeight = `${this.summary.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
        }, {
            duration: 400,
            easing: 'ease-out',
        }, );

        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(false);
        // If the animation is cancelled, isClosing variable is set to false
        this.animation.oncancel = () => (this.isClosing = false);
    }

    open() {
        // Apply a fixed height on the element
        this.el.style.height = `${this.el.offsetHeight}px`;
        // Force the [open] attribute on the details element
        this.el.open = true;
        // Wait for the next frame to call the expand function
        window.requestAnimationFrame(() => this.expand());
    }

    expand() {
        // Set the element as "being expanding"
        this.isExpanding = true;
        // Get the current fixed height of the element
        const startHeight = `${this.el.offsetHeight}px`;
        // Calculate the open height of the element (summary height + content height)
        const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

        // If there is already an animation running
        if (this.animation) {
            // Cancel the current animation
            this.animation.cancel();
        }

        // Start a WAAPI animation
        this.animation = this.el.animate({
            // Set the keyframes from the startHeight to endHeight
            height: [startHeight, endHeight],
        }, {
            duration: 400,
            easing: 'ease-out',
        }, );
        // When the animation is complete, call onAnimationFinish()
        this.animation.onfinish = () => this.onAnimationFinish(true);
        // If the animation is cancelled, isExpanding variable is set to false
        this.animation.oncancel = () => (this.isExpanding = false);
    }

    onAnimationFinish(open) {
        // Set the open attribute based on the parameter
        this.el.open = open;
        // Clear the stored animation
        this.animation = null;
        // Reset isClosing & isExpanding
        this.isClosing = false;
        this.isExpanding = false;
        // Remove the overflow hidden and the fixed height
        this.el.style.height = this.el.style.overflow = '';
    }
}

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.accordion.smooth details').forEach((el) => {
        new Accordion(el);
    });
});


document.addEventListener('DOMContentLoaded', function() {
    const detailsElements = document.querySelectorAll('.header__inline-menu .list-menu .mega-menu');

    detailsElements.forEach((details) => {
        const summary = details.querySelector('summary');
        const submenu = details.querySelector('.mega-menu__content');

        const keepOpen = (event) => {
            details.setAttribute('open', '');
            if (summary) {
                summary.setAttribute('aria-expanded', 'true');
            }
        };

        const closeMenu = (event) => {
            details.removeAttribute('open');
            if (summary) {
                summary.setAttribute('aria-expanded', 'false');
            }
        };

        // Keep menu open on hover
        details.addEventListener('mouseenter', keepOpen);
        details.addEventListener('mouseleave', closeMenu);

        // Prevent menu from closing when hovering over submenu
        if (submenu) {
            submenu.addEventListener('mouseenter', keepOpen);
            submenu.addEventListener('mouseleave', closeMenu);
        }
    });
});



function setupSizeDropdowns() {
    let activeDropdown = null;

    function openDropdown(trigger) {
        const href = trigger.getAttribute("href");
        const targetId = href ? href.substring(1) : null;
        const targetDropdown = document.getElementById(targetId);

        if (targetDropdown) {
            targetDropdown.classList.add("active");
            activeDropdown = targetDropdown;
        }
    }

    function closeDropdown() {
        if (activeDropdown) {
            activeDropdown.classList.remove("active");
            activeDropdown = null;
        }
    }

    // Open dropdown on hover (for desktop)
    document.addEventListener(
        "mouseenter",
        function(event) {
            if (!event.target || !event.target.closest) return;
            const trigger = event.target.closest("[data-size-drop-trigger]");
            if (trigger) {
                openDropdown(trigger);
            }
        },
        true
    );

    // Close dropdown when mouse leaves the parent .card-wrapper element
    document.addEventListener(
        "mouseleave",
        function(event) {
            if (!event.target || !event.target.closest) return;
            const cardWrapper = event.target.closest(".card-wrapper");
            if (cardWrapper && !cardWrapper.contains(event.relatedTarget)) {
                closeDropdown();
            }
        },
        true
    );

    // Open dropdown on click (for mobile)
    document.addEventListener("click", function(event) {
        if (!event.target || !event.target.closest) return;
        const trigger = event.target.closest("[data-size-drop-trigger]");

        if (trigger) {
            event.preventDefault(); // Prevent default anchor behavior

            // Toggle dropdown (clicking again closes it)
            if (activeDropdown && activeDropdown === trigger.closest(".card-wrapper").querySelector(".size-dropdown")) {
                closeDropdown();
            } else {
                closeDropdown(); // Close any open dropdown before opening a new one
                openDropdown(trigger);
            }
        }

        // Close if clicking outside
        if (!event.target.closest(".size-dropdown") && !trigger) {
            closeDropdown();
        }
    });

    // Close dropdown when clicking the close button inside the dropdown
    document.addEventListener("click", function(event) {
        if (!event.target || !event.target.closest) return;
        const closeButton = event.target.closest("[data-size-drop-close]");
        if (closeButton) {
            closeDropdown();
        }
    });
}

// Initialize the function after DOM content is loaded
document.addEventListener("DOMContentLoaded", setupSizeDropdowns);




function quickadd(variantId) {
    fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                id: variantId,
                quantity: 1
            })
        })
        .then(response => response.json())
        .then(data => {
            fetch(`${routes.cart_url}?section_id=cart-drawer`)
                .then(res => res.text())
                .then(html => {
                    const parser = new DOMParser();
                    const doc = parser.parseFromString(html, 'text/html');
                    const newCart = doc.querySelector('cart-drawer');
                    if (newCart) {
                        document.querySelector('cart-drawer').innerHTML = newCart.innerHTML;

                        const SizeDropdown = document.querySelectorAll('.card__size-dropdown.active');
                        SizeDropdown.forEach(dropdown => {
                            dropdown.classList.remove('active');
                        });
                        document.querySelector('cart-drawer').classList.remove('is-empty');
                        document.querySelector('cart-drawer').classList.add('active');
                        setTimeout(() => {
                            if (typeof window.updateCartRecommendations === 'function') {
                                window.updateCartRecommendations();
                            }
                        }, 50);
                    }
                });
        })
        .catch(error => console.error('Error adding to cart:', error));
}


document.addEventListener('DOMContentLoaded', function() {
    window.dropdownClick = function(element) {
        const dropdown = element.closest('.custom-sort-dropdown');
        const dropdownMenu = dropdown.querySelector(".dropdown-menu");

        // Close all dropdowns except the clicked one
        document.querySelectorAll(".dropdown-menu").forEach(menu => {
            if (menu !== dropdownMenu) {
                menu.classList.add("hidden");
            }
        });

        dropdownMenu.classList.toggle("hidden");
    };

    window.changeSortValue = function(option) {
        const dropdown = option.closest('.custom-sort-dropdown');
        const dropdownMenu = dropdown.querySelector('.dropdown-menu');
        const selectedText = dropdown.querySelector(".selected-text");
        const selectElement = dropdown.querySelector("[data-custom-dropdown]"); // Hidden <select>

        // Update selected text based on clicked option
        selectedText.textContent = option.textContent;

        // Update the hidden <select> element value
        selectElement.value = option.getAttribute("data-value");

        // Dispatch input event to trigger any custom actions based on the <select> change
        selectElement.dispatchEvent(new Event("input", {
            bubbles: true
        }));

        // Mark the selected option
        dropdown.querySelectorAll(".dropdown-option").forEach(opt => opt.removeAttribute("data-selected"));
        option.setAttribute("data-selected", "true");

        // Close the dropdown
        dropdownMenu.classList.add("hidden");
    };

    // Close dropdown when clicking outside
    document.addEventListener("click", function(event) {
        if (!event.target.closest(".custom-sort-dropdown")) {
            document.querySelectorAll(".dropdown-menu").forEach(menu => menu.classList.add("hidden"));
        }
    });
});


document.addEventListener('DOMContentLoaded', function() {
    /////////////// According Smooth Toggle Animation //////////////
    class Accordion {
        constructor(el) {
            // Store the <details> element
            this.el = el;
            // Store the <summary> element
            this.summary = el.querySelector('summary');
            // Store the <div class="content"> element
            this.content = el.querySelector('.accordion__content');

            // Store the animation object (so we can cancel it if needed)
            this.animation = null;
            // Store if the element is closing
            this.isClosing = false;
            // Store if the element is expanding
            this.isExpanding = false;
            // Detect user clicks on the summary element
            this.summary.addEventListener('click', (e) => this.onClick(e));
        }

        onClick(e) {
            // Stop default behaviour from the browser
            e.preventDefault();
            // Add an overflow on the <details> to avoid content overflowing
            this.el.style.overflow = 'hidden';
            // Check if the element is being closed or is already closed
            if (this.isClosing || !this.el.open) {
                this.open();
                // Check if the element is being openned or is already open
            } else if (this.isExpanding || this.el.open) {
                this.shrink();
            }
        }

        shrink() {
            // Set the element as "being closed"
            this.isClosing = true;

            // Store the current height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the height of the summary
            const endHeight = `${this.summary.offsetHeight}px`;

            // If there is already an animation running
            if (this.animation) {
                // Cancel the current animation
                this.animation.cancel();
            }

            // Start a WAAPI animation
            this.animation = this.el.animate({
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            }, {
                duration: 400,
                easing: 'ease-out'
            });

            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(false);
            // If the animation is cancelled, isClosing variable is set to false
            this.animation.oncancel = () => this.isClosing = false;
        }

        open() {
            // Apply a fixed height on the element
            this.el.style.height = `${this.el.offsetHeight}px`;
            // Force the [open] attribute on the details element
            this.el.open = true;
            // Wait for the next frame to call the expand function
            window.requestAnimationFrame(() => this.expand());
        }

        expand() {
            // Set the element as "being expanding"
            this.isExpanding = true;
            // Get the current fixed height of the element
            const startHeight = `${this.el.offsetHeight}px`;
            // Calculate the open height of the element (summary height + content height)
            const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

            // If there is already an animation running
            if (this.animation) {
                // Cancel the current animation
                this.animation.cancel();
            }

            // Start a WAAPI animation
            this.animation = this.el.animate({
                // Set the keyframes from the startHeight to endHeight
                height: [startHeight, endHeight]
            }, {
                duration: 400,
                easing: 'ease-out'
            });
            // When the animation is complete, call onAnimationFinish()
            this.animation.onfinish = () => this.onAnimationFinish(true);
            // If the animation is cancelled, isExpanding variable is set to false
            this.animation.oncancel = () => this.isExpanding = false;
        }

        onAnimationFinish(open) {
            // Set the open attribute based on the parameter
            this.el.open = open;
            // Clear the stored animation
            this.animation = null;
            // Reset isClosing & isExpanding
            this.isClosing = false;
            this.isExpanding = false;
            // Remove the overflow hidden and the fixed height
            this.el.style.height = this.el.style.overflow = '';
        }
    }

    document.querySelectorAll('.accordion.product__accordion details').forEach((el) => {
        new Accordion(el);
    });


    /////////////// Close Exsting According //////////////
    class AccordionToggle {
        constructor(el, accordionGroup) {
            this.el = el;
            this.summary = el.querySelector('summary');
            this.content = el.querySelector('.accordion__content');

            this.animation = null;
            this.isClosing = false;
            this.isExpanding = false;
            this.accordionGroup = accordionGroup;

            // Set aria-expanded based on the initial open state
            this.updateAriaExpanded(this.el.open);

            this.summary.addEventListener('click', (e) => this.onClick(e));
        }

        onClick(e) {
            e.preventDefault();
            this.el.style.overflow = 'hidden';

            // Close all other accordions
            this.accordionGroup.closeAllExcept(this);

            if (this.isClosing || !this.el.open) {
                this.open();
            } else if (this.isExpanding || this.el.open) {
                this.shrink();
            }
        }

        shrink() {
            this.isClosing = true;
            const startHeight = `${this.el.offsetHeight}px`;
            const endHeight = `${this.summary.offsetHeight}px`;

            if (this.animation) {
                this.animation.cancel();
            }

            this.animation = this.el.animate({
                height: [startHeight, endHeight]
            }, {
                duration: 400,
                easing: 'ease-out'
            });

            this.animation.onfinish = () => this.onAnimationFinish(false);
            this.animation.oncancel = () => this.isClosing = false;
        }

        open() {
            this.el.style.height = `${this.el.offsetHeight}px`;
            this.el.open = true;

            this.accordionGroup.currentAccordion = this;

            window.requestAnimationFrame(() => this.expand());
        }

        expand() {
            this.isExpanding = true;
            const startHeight = `${this.el.offsetHeight}px`;
            const endHeight = `${this.summary.offsetHeight + this.content.scrollHeight}px`; // Use scrollHeight for precise measurement

            if (this.animation) {
                this.animation.cancel();
            }

            this.animation = this.el.animate({
                height: [startHeight, endHeight]
            }, {
                duration: 400,
                easing: 'ease-out'
            });

            this.animation.onfinish = () => this.onAnimationFinish(true);
            this.animation.oncancel = () => this.isExpanding = false;
        }

        onAnimationFinish(open) {
            this.el.open = open;
            this.animation = null;
            this.isClosing = false;
            this.isExpanding = false;
            this.el.style.height = '';
            this.el.style.overflow = '';

            this.updateAriaExpanded(open);

            if (!open) {
                this.accordionGroup.currentAccordion = null;
            }
        }

        updateAriaExpanded(isExpanded) {
            this.summary.setAttribute('aria-expanded', isExpanded ? 'true' : 'false');
        }

        close() {
            if (this.el.open) {
                this.shrink();
            }
        }
    }

    class AccordionGroup {
        constructor() {
            this.currentAccordion = null;
            this.accordions = [];
        }

        init() {
            document.querySelectorAll('.accordion.product__accordion details').forEach(el => {
                //el.open = false;
                const accordion = new AccordionToggle(el, this);
                this.accordions.push(accordion);
            });
        }

        closeAllExcept(currentAccordion) {
            this.accordions.forEach(accordion => {
                if (accordion !== currentAccordion) {
                    accordion.close();
                }
            });
        }
    }

    const accordionGroup = new AccordionGroup();
    accordionGroup.init();

});

document.addEventListener("DOMContentLoaded", function() {
    document.querySelectorAll('.deferred-media[data-autoplay-true]').forEach(media => {
        const button = media.querySelector('button[type="button"]');
        if (button) {
            button.click(); // Trigger deferred loading
        }

        // Wait a bit for the video element to appear
        setTimeout(() => {
            const video = media.querySelector("video");
            if (video) {
                video.play().catch(err => console.warn("Video autoplay failed:", err));
            }
        }, 500); // Adjust timeout if necessary
    });
});

document.addEventListener("DOMContentLoaded", function() {
    const toggler = document.querySelector(".toggler");
    const giftCardBlock = document.querySelector(".gift-card-block__content");
    const checkbox = document.getElementById("gift-card-added");
    const textarea = document.querySelector(".gift-card-textarea");
    const charCountLabel = document.querySelector(".char-count");

    if (toggler && giftCardBlock && checkbox) {
        toggler.addEventListener("click", function() {
            // Toggle visibility of gift card block
            const isOpen = giftCardBlock.classList.toggle("hidden");

            // Check/uncheck the checkbox accordingly
            checkbox.checked = !isOpen;

            // Toggle active class on button
            toggler.classList.toggle("active", !isOpen);
        });
    }

    if (textarea && charCountLabel) {
        const charLimit = parseInt(textarea.dataset.charLimit, 10) || 0;

        textarea.addEventListener("input", function() {
            if (textarea.value.length > charLimit) {
                textarea.value = textarea.value.substring(0, charLimit);
            }
            const remainingChars = charLimit - textarea.value.length;
            charCountLabel.textContent = remainingChars >= 0 ? remainingChars : 0;
        });
    }
});



// Cart Drawer widget
window.updateCartRecommendations = async function() {
    const productId = getLatestProductId();
    if (productId) {
        await fetchRecommendations(productId); // Wait for recommendations to load
        setTimeout(() => {
            const swiperContainer = document.querySelector('.cart-drawer-upsell-slider');
            if (swiperContainer) {
                initializeSwiperCartDrawerSlider(); // Initialize Swiper safely after recommendations load
            }
        }, 20);
    }
    //console.log('productId', productId);
};


function getLatestProductId() {
    const firstCartItem = document.querySelector('#CartDrawer-CartItems tr.cart-item');
    return firstCartItem ? firstCartItem.dataset.productId : null;
}

function updateQuickAdd(select, buttonId) {
    const selectedVariantId = select.value;
    document.getElementById(buttonId).setAttribute('onclick', `quickadd(${selectedVariantId})`);
}


function fetchRecommendations(productId) {
    if (!productId) return;

    fetch(`${window.Shopify.routes.root}recommendations/products.json?product_id=${productId}&limit=10&intent=related`)
        .then(response => response.json())
        .then(({
            products
        }) => {
            if (products.length > 0) {
                renderRecommendations(products);
            }
        })
        .catch(error => console.error('Error fetching recommendations:', error));
}


function renderRecommendations(products) {
    const recommendationsContainer = document.querySelector('[data-cart-recommendations]');
    if (!recommendationsContainer) return;

    // Get dynamic CTA text from the data attribute
    const ctaText = recommendationsContainer.getAttribute('data-cta-text') || 'Add to cart';

    recommendationsContainer.innerHTML = `

  <div class="cart-drawer-upsell-slider">
    <div class="swiper-wrapper">
    ${products.map(product => `
          <div class="swiper-slide">
            <div class="cart-recommendation-item">
              <div class="cart-recommendation-item__image">
                <a href="${product.url}">
                  <img src="${product.featured_image}&width=150" alt="${product.title}">
                </a>
              </div>
              <div class="cart-recommendation-item__content">
                <h3>${product.title}</h3>
                <div class="cart-recommendation-item__content-price">
                    <span>${Shopify.formatMoney(product.price)}</span>
                </div>
                <div class="cart-recommendation-item__content-cta">
                  ${product.variants.length > 1 ? `
                    <select class="product-variant-select" onchange="updateQuickAdd(this, 'quickadd-btn-${product.id}')">
                        ${product.variants.map(variant => `
                            <option value="${variant.id}">
                                ${variant.title}
                            </option>
                        `).join('')}
                    </select>
                  ` : ''}
                  <button class="button" id="quickadd-btn-${product.id}" onclick="quickadd(${product.variants[0].id})">
                      ${ctaText} 
                  </button>
                </div>
              </div>
            </div>
        </div>
    `).join('')}
  </div>
  </div>
  <div class="swiper-arrow swiper-button-next">
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.66685 6.9147L1.99166 0.239632C1.83727 0.0851213 1.63118 0 1.41142 0C1.19167 0 0.985572 0.0851213 0.831183 0.239632L0.339602 0.731092C0.0197263 1.05133 0.0197263 1.57182 0.339602 1.89157L5.94492 7.49689L0.333382 13.1084C0.178993 13.2629 0.09375 13.4689 0.09375 13.6885C0.09375 13.9084 0.178993 14.1144 0.333382 14.269L0.824964 14.7604C0.979475 14.9149 1.18545 15 1.4052 15C1.62496 15 1.83105 14.9149 1.98544 14.7604L8.66685 8.0792C8.82161 7.9242 8.90661 7.71725 8.90612 7.49726C8.90661 7.2764 8.82161 7.06958 8.66685 6.9147Z" fill="black"/>
    </svg>
  </div>
  <div class="swiper-arrow swiper-button-prev">
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0.333148 6.9147L7.00834 0.239632C7.16273 0.0851213 7.36882 0 7.58858 0C7.80833 0 8.01443 0.0851213 8.16882 0.239632L8.6604 0.731092C8.98027 1.05133 8.98027 1.57182 8.6604 1.89157L3.05508 7.49689L8.66662 13.1084C8.82101 13.2629 8.90625 13.4689 8.90625 13.6885C8.90625 13.9084 8.82101 14.1144 8.66662 14.269L8.17504 14.7604C8.02053 14.9149 7.81455 15 7.5948 15C7.37504 15 7.16895 14.9149 7.01456 14.7604L0.333148 8.0792C0.178393 7.9242 0.0933943 7.71725 0.0938816 7.49726C0.0933943 7.2764 0.178393 7.06958 0.333148 6.9147Z" fill="black"/>
    </svg>
  </div>
  `;
    // Ensure Swiper runs after DOM update
    setTimeout(() => {
        initializeSwiperCartDrawerSlider();
    }, 50);
}

window.updateCartRecommendations();

// Ensure Swiper initializes safely
function initializeSwiperCartDrawerSlider() {
    const swiperEl = document.querySelector('.cart-drawer-upsell-slider');
    if (!swiperEl) return; // Prevent errors if element is missing
    console.log('initializeSwiperCartDrawerSlider')
    new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 10,
        loop: true,
        navigation: {
            nextEl: '.drawer__upsell .swiper-button-next',
            prevEl: '.drawer__upsell .swiper-button-prev',
        },
    });
}

document.addEventListener("DOMContentLoaded", function() {
    const path = window.location.pathname;

    // ✅ Redirect from /cart to homepage with a session flag
    if (path === "/cart") {
        sessionStorage.setItem("openCartDrawer", "true");
        window.location.replace("/"); // immediate redirect without back history
        return;
    }

    // ✅ On homepage, check flag and open the cart drawer
    if (path === "/") {
        const shouldOpenDrawer = sessionStorage.getItem("openCartDrawer");

        if (shouldOpenDrawer === "true") {
            const drawer = document.querySelector("cart-drawer");

            if (drawer) {
                drawer.classList.add("active"); // Or use drawer.open() if defined
            }

            sessionStorage.removeItem("openCartDrawer");
        }
    }
});


const recover_password = document.querySelector(".recover_password");
const accountDrawer = document.querySelector(".account-drawer");

if (recover_password && accountDrawer) {
    recover_password.addEventListener("click", function() {
        accountDrawer.classList.add("active");
    });
}


/**
 * Applies reverse text direction to english products title in right-to-left languages.
 * This function only runs when the HTML element has lang="he-IL" attribute.
 * It checks if the product title contains only English characters (no Hebrew),
 * and if so, adds the "reverse" class to both the title and description wrappers.
 * This is intended for products with data-watch="true" that display English-only content
 * in a right-to-left language context.
 */
function applyReverseDirectionForEnglishContent() {
    // Check if HTML has lang="he-IL" - only proceed if page is in Hebrew
    const htmlLang = document.documentElement.getAttribute("lang");
    if (htmlLang !== "he-IL") return;

    console.log('applyReverseDirectionForEnglishContent');


    // Check if product-info element exists and has data-watch="true"
    const productInfo = document.querySelector("product-info");
    if (!productInfo || productInfo.dataset.watch !== "true") return;

    // Get the necessary DOM elements
    const titleEl = document.querySelector(".product__title h1");
    const titleWrapper = document.querySelector(".product__title");
    const descriptionWrapper = document.querySelector(".product__description");
    const brandText = document.querySelector(".product__text.inline-richtext");
    const productSku = document.querySelector(".product__sku");

    // Ensure all required elements exist before proceeding
    if (!titleEl || !titleWrapper || !descriptionWrapper) return;

    // Get the title text content
    const text = titleEl.textContent.trim();

    // Hebrew unicode range: \u0590-\u05FF covers all Hebrew characters
    const hebrewRegex = /[\u0590-\u05FF]/;

    // Check if title contains only English characters (no Hebrew)
    const isEnglishOnly = !hebrewRegex.test(text);

    // Apply reverse class to title and description wrappers if content is English-only
    if (isEnglishOnly) {
        titleWrapper.classList.add("reverse");
        descriptionWrapper.classList.add("reverse");
        brandText.classList.add("reverse");
        productSku.classList.add("reverse");
    }
}

document.addEventListener("DOMContentLoaded", function() {
    const money = document.querySelectorAll(".money");
    const options = document.querySelectorAll(".doubly-nice-select .option");
    options.forEach(option => {
        option.addEventListener("click", function() {
            const newCurrency = this.dataset.value;
            convertCurrencyChange(newCurrency);
        });
    });

    convertCurrency();

    function convertCurrencyChange(newCurrency) {
        if (newCurrency && newCurrency === 'ILS') {
            document.querySelector(".cart-drawer__currency-message").style.display = "none";
        } else {
            document.querySelector(".cart-drawer__currency-message").style.display = "block";
        }
    }

    function convertCurrency() {
        if (money) {
            money.forEach(item => {
                let currency = item.getAttribute("doubly-currency");
                console.log(currency);
                if (currency == 'ILS') {
                    document.querySelector(".cart-drawer__currency-message").style.display = "none";
                } else {
                    document.querySelector(".cart-drawer__currency-message").style.display = "block";
                }
            });
        }
    }

    // Apply reverse direction for English-only product content
    applyReverseDirectionForEnglishContent();
});




document.addEventListener("DOMContentLoaded", function () {
  const interval = setInterval(() => {
    const embed = document.querySelector("shopify-forms-embed");

    if (!embed) return;

    const shadow = embed.shadowRoot;
    if (!shadow) return;

    const container = shadow.querySelector("#app-embed");
    if (!container) return;

    // Check if style already exists, if so update it, otherwise create new
    let styleEl = shadow.querySelector('style[data-shopify-forms-custom]');
    if (!styleEl) {
      styleEl = document.createElement("style");
      styleEl.setAttribute('data-shopify-forms-custom', 'true');
      shadow.appendChild(styleEl);
    }

    // Check document lang attribute (shadow DOM can't access parent document attributes)
    const documentLang = document.documentElement.getAttribute('lang');
    const isHebrew = documentLang === 'he-IL';
    const checkboxRtlRule = isHebrew ? `
    ._checkboxField_1hja3_3, span._textBody_2aowh_10, h2, ._textBody_2aowh_10 p {
       direction: rtl !important;
    }` : '';

    // ---- Inject CSS inside shadow root ----
    styleEl.textContent = `
  
      h2 {
        font-family: 'Rag Sans-1.4.2' !important;
        font-weight: 600 !important;
        font-size: 20px !important;
        line-height: 20px !important;
        text-align: center !important;
      }
       /* Keep labels in same position - no movement or scaling on focus */
       input ~ label,
       input:focus ~ label,
       input:focus-within ~ label,
       input[type="text"] ~ label,
       input[type="text"]:focus ~ label,
       input[type="text"]:focus-within ~ label,
       input[type="email"] ~ label,
       input[type="email"]:focus ~ label,
       input[type="email"]:focus-within ~ label,
       input[type="tel"] ~ label,
       input[type="tel"]:focus ~ label,
       input[type="tel"]:focus-within ~ label {
            top: 12px !important;
            font-size: 9px !important;
            transform: none !important;
            scale: 1 !important;
            position: absolute !important;
         }
       
       /* Hide label when input has value (user is typing) */
       input:not(:placeholder-shown) ~ label,
       input.has-value ~ label,
       input[type="text"]:not(:placeholder-shown) ~ label,
       input[type="text"].has-value ~ label,
       input[type="email"]:not(:placeholder-shown) ~ label,
       input[type="email"].has-value ~ label,
       input[type="tel"]:not(:placeholder-shown) ~ label,
       input[type="tel"].has-value ~ label {
            display: none !important;
            opacity: 0 !important;
            visibility: hidden !important;
         }
    ${checkboxRtlRule}
      ._textBody_2aowh_10 p {
        font-family: 'Rag Sans-1.4.2' !important;
        font-weight: 400 !important;
        font-size: 12px !important;
        line-height: 14px !important;
        text-align: center !important;
      }

      button[type="submit"], button[data-testid="btn-form-submit"], button._formSubmitButton_cit2d_96, button[type="submit"]._formSubmitButton_cit2d_96, button[data-testid="btn-form-submit"]._formSubmitButton_cit2d_96{
         font-family: 'Rag Sans-1.4.2' !important;
        font-weight: 400 !important;
        font-size: 12px !important;
        line-height: 14px !important;
        text-decoration: underline !important;
        background: transparent !important;
        color: #000 !important;
        border: none !important;
        padding: 0 !important;
        text-align: center !important;
        cursor: pointer !important;
        }

      input {
        height: 22px !important;
        border: 0.5px solid rgba(0,0,0,0.5) !important;
        border-radius: 0 !important;
        padding: 5px 3px !important;
        width: 100% !important;
        // box-shadow: none !important;
         font-size: 9px !important;
      }
       
      .phone-country-selector button{
           padding: 6.5px;
           border-radius: 0;
           border: 0.5px solid rgba(0,0,0,0.5) !important;
      }
     .phone-country-selector button span{
         justify-content: center !important;
      }
     ._formPhoneInputContainer_piv1u_6{
        grid-template-columns: minmax(0px, 50px) minmax(0px, 2.2fr) !important;
    }
    #label-phone_number{
    font-size: 12px !important;
    }
   
    input[type="tel"]{
        width: 100% !important;
        text-align: center !important;
    }
    ._formPhoneInputContainer_piv1u_6 ._formFieldContainer_1mxsl_5  label{
            display: none !important;
     }
     ._gridItemContent_1q1d2_257{
         padding: 90px 35px !important;
     }
     @media screen and (max-width: 749px) {
         ._gridItemContent_1q1d2_257{
             padding-top: 0 !important;
             padding-bottom: 50px !important;
         }
             ._formBannerContainer_z5ku3_1{
                padding-top: 50px !important;
             }
                  #label-phone_number,
                  input{
                    font-size: 16px !important;
                  }
                  
         /* Make labels visible on iPhone/mobile - override small font-size */
         input ~ label,
         input[type="text"] ~ label,
         input[type="email"] ~ label,
         input[type="tel"] ~ label {
           font-size: 16px !important;
           color: #000 !important;
         }
         
         /* Override hide rules for empty inputs on mobile - show labels when input is empty */
         input:placeholder-shown ~ label,
         input:not(.has-value) ~ label {
           display: block !important;
           opacity: 1 !important;
           visibility: visible !important;
         }
     }
     input[type="text"]{
            margin-top: 0px !important;
            width: 100% !important;
    } 
    input[type="text"] ~ label{
        font-size: 12px !important;
    }
      input[type="checkbox"] {
        width: 14px !important;
        height: 14px !important;
        border: 0.5px solid rgba(0,0,0,0.5) !important;
      }

      
    `;

    // Add event listeners to hide/show labels when typing
    // Use a flag to prevent duplicate listeners
    if (!container.dataset.labelHandlersAdded) {
      const inputs = shadow.querySelectorAll('input[type="text"], input[type="email"], input[type="tel"], input:not([type="checkbox"]):not([type="radio"]):not([type="submit"]):not([type="button"])');
      inputs.forEach(input => {
        // Check initial value
        if (input.value && input.value.trim() !== '') {
          input.classList.add('has-value');
        }
        
        // Handle input events (when user types)
        const handleInput = function() {
          if (this.value && this.value.trim() !== '') {
            this.classList.add('has-value');
          } else {
            this.classList.remove('has-value');
          }
        };
        
        input.addEventListener('input', handleInput);
        input.addEventListener('blur', handleInput);
      });
      
      // Mark as processed to avoid duplicate listeners
      container.dataset.labelHandlersAdded = 'true';
    }

    // Check if button exists and apply styles directly as fallback
    const submitButton = shadow.querySelector('button[type="submit"], button[data-testid="btn-form-submit"]');
    if (submitButton && styleEl.parentNode) {
      // Apply styles directly to button as fallback (inline styles have high specificity)
      submitButton.style.fontFamily = "'Rag Sans-1.4.2'";
      submitButton.style.fontWeight = '400';
      submitButton.style.fontSize = '12px';
      submitButton.style.lineHeight = '14px';
      submitButton.style.textDecoration = 'underline';
      submitButton.style.background = 'transparent';
      submitButton.style.color = '#000';
      submitButton.style.border = 'none';
      submitButton.style.padding = '0';
      submitButton.style.textAlign = 'center';
      submitButton.style.cursor = 'pointer';
      
      clearInterval(interval);
    }
  }, 300);
});

// Hide Outlet for Non-IL

  window.addEventListener("load", function () {
    if (window.__marketCountry !== "IL") {
      const el = document.getElementById("HeaderMenu-outlet");
      const li = el && el.closest("li");
      if (li) li.style.display = "none";
    }
  });


  document.querySelectorAll('.image-zoom-container').forEach(container => {
    const img = container.querySelector('img');
    const zoom = 2; // zoom level
  
    container.addEventListener('mousemove', e => {
      const rect = container.getBoundingClientRect();
      const x = ((e.clientX - rect.left) / rect.width) * 100;
      const y = ((e.clientY - rect.top) / rect.height) * 100;
  
      img.style.transformOrigin = `${x}% ${y}%`;
      img.style.transform = `scale(${zoom})`;
    });
  
    container.addEventListener('mouseleave', () => {
      img.style.transform = 'scale(1)';
      img.style.transformOrigin = 'center center';
    });
  });
  